import { Pagination } from "@core/domain/models/pagination";
import { ContractsRepository } from "@entity/data/repositories/contracts.repository";
import {
    EmployeeContract,
    EmployeeContractSearchFilters,
} from "@entity/domain/models/employee/contracts/employee/employee-contract.model";
import { inject, injectable } from "inversify";

@injectable()
export class GetAllEmployeeContractsByUseCase {
    constructor(
        @inject(ContractsRepository)
        private readonly contractsRepository: ContractsRepository,
    ) {}

    async execute(
        filters?: EmployeeContractSearchFilters,
    ): Promise<EmployeeContract[]> {
        const contractsResult =
            await this.contractsRepository.getAllEmployeeContractsBy(
                Pagination.NoPagination(),
                filters,
            );

        return contractsResult.fold(
            () => [],
            (contracts) => contracts.employeeContracts,
        );
    }
}
